import React from "react";
import {isRichText, sanitizeRichText} from "./rich-text-utils";
import "./rich-text.css";

// Shows a description, report or note: the editor's HTML (sanitized) or an old plain text with its line breaks.
// `empty` is shown when there is nothing written.
function RichTextView({value, className = "", empty = null, as: Tag = "div"}) {
    const text = value === null || value === undefined ? "" : String(value);
    if (!text.trim()) return empty;
    if (!isRichText(text)) return <Tag className={`zr-view zr-plain ${className}`} dir="auto">{text}</Tag>;
    return <Tag className={`zr-view ${className}`} dir="auto" dangerouslySetInnerHTML={{__html: sanitizeRichText(text)}}/>;
}

export default RichTextView;
